import { useEffect, useState } from "react";

// Routes where gamification chrome (XpBadge, StreakFlame) is shown.
// LivesIndicator is mounted per-page where relevant — not scoped here.
// /profile is included so the page can compose StreakFlame/LivesIndicator
// inline (the components still self-gate on user being signed in).
const SCOPED_PREFIXES = ["/labs", "/academy", "/profile"];

const matches = (pathname) =>
  SCOPED_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );

// One-time install of pushState/replaceState wrappers that emit
// custom events. Gatsby's Link/navigate uses pushState; popstate alone
// would miss in-app forward navigations.
const installHistoryHooks = () => {
  if (typeof window === "undefined") return;
  if (window.__gameRouteHooked) return;
  window.__gameRouteHooked = true;
  const wrap = (orig, name) =>
    function patched() {
      const ret = orig.apply(this, arguments);
      window.dispatchEvent(new Event(name));
      return ret;
    };
  window.history.pushState = wrap(window.history.pushState, "gr:pushstate");
  window.history.replaceState = wrap(
    window.history.replaceState,
    "gr:replacestate"
  );
};

export default function useGameRoute() {
  const [pathname, setPathname] = useState(
    typeof window !== "undefined" ? window.location.pathname : ""
  );
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    installHistoryHooks();
    const update = () => setPathname(window.location.pathname);
    update();
    window.addEventListener("popstate", update);
    window.addEventListener("gr:pushstate", update);
    window.addEventListener("gr:replacestate", update);
    return () => {
      window.removeEventListener("popstate", update);
      window.removeEventListener("gr:pushstate", update);
      window.removeEventListener("gr:replacestate", update);
    };
  }, []);
  return matches(pathname);
}
